export default __webpack_public_path__ + "static/media/havana-01.ba43423b.png";